export var getEventTarget = function (event) {
  var target = event.target;
  if (target && target.shadowRoot) {
    target = event.composedPath()[0];
  }
  return target;
};